export default new Promise((resolve) => {
  resolve({
    install(app) {
      if (!app.config.globalProperties.config) {
        app.config.globalProperties.config = config;
      }
    },
  });
});
